
import * as React from 'react';
import style from './WSpinner.less';
import * as classNames from 'classnames';


export interface WSpinnerProps extends React.ClassAttributes<any> {
    label?: string;
}

export class WSpinner extends React.Component<WSpinnerProps, {}>  {

    constructor(props: any) {
        super(props);
    }

    render() {
        return (<div className={style.loader}>
            <span className={style.a}><div style={{ paddingTop: '20px' }}>
                {this.props.label ? this.props.label : 'Laden'}
            </div></span>
            <span className={classNames(style.b, style.spin)}>
                <span className={style.c}></span>
            </span>
        </div>);
    }
}
